import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.bannerClassList,
      style: {
        bottom: _vm.fixedBottomValue ? _vm.fixedBottomValue : "initial",
        maxWidth: "800px",
      },
      attrs: { "data-qa": "club_detail_info_banner" },
    },
    [
      _c(
        "div",
        {
          staticClass: "club-detail-info-banner__content",
          class: {
            "d-flex align-center justify-space-between": !_vm.isMobile,
          },
        },
        [
          _c("div", { staticClass: "text--text" }, [
            _c(
              "div",
              {
                staticClass: "text-subtitle-1",
                attrs: { "data-qa": "club_detail_info_banner_title" },
              },
              [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
            ),
            _vm._v(" "),
            _vm.subtitle
              ? _c("div", {
                  staticClass: "text-body-2 mt-1",
                  attrs: { "data-qa": "club_detail_info_banner_subtitle" },
                  domProps: { innerHTML: _vm._s(_vm.subtitle) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.textButton
            ? _c(
                VBtn,
                {
                  staticClass: "club-detail-info-banner__button",
                  class: _vm.isMobile ? "mt-3" : "ml-3",
                  attrs: {
                    "data-qa": "club_detail_info_banner_button",
                    small: _vm.isMobile,
                    depressed: "",
                  },
                  on: { click: _vm.emitClickButton },
                },
                [
                  _c("span", { staticClass: "bg-gray-0--text" }, [
                    _vm._v("\n        " + _vm._s(_vm.textButton) + "\n      "),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }